module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/illinois-state-62ec3beeaf247ed52fe987a8eb83fde3.svg";